"use strict";

export default class AppSettingsController {
  /*@ngInject*/
  constructor(Settings, Applications, settings, Modal) {
    this._Settings = Settings;
    this.settings = settings;
    this._Applications = Applications;
    this._Modal = Modal;
  }
  save(setting) {
    this._Settings.save(setting).then(
      (response) => {
        console.log(response);
      },
      (err) => {
        console.log(err);
        this.error = err.data.message;
      }
    );
  }

  assignIds(type) {
    this._Modal
      .confirmation(
        "Are you sure you want to reset ALL the homeowner ids?!? This cannot be undone!!!!!!!!",
        "Reset ALL Homeowner ID"
      )
      .then(() => {
        this._Applications.assignIds({ override: true, type: type }).then(
          (response) => {
            console.log(response);
          },
          (err) => {
            console.log(err);
            this.error = err.data.message;
          }
        );
      });
  }

  sendAllIds() {
    this._Modal
      .confirmation(
        "Are you sure you want to send all the homeowner IDs to the customer's emails??? THIS CANNOT BE STOPPED!!! MWAHAHAHAHAHA!!!",
        "Send All Homeowner Ids"
      )
      .then(() => {
        this._Applications.sendAllIds().then(
          (response) => {
            console.log(response);
          },
          (err) => {
            console.log(err);
            this.error = err.data.message;
          }
        );
      });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/settings.controller.js